import React, { useState, useEffect } from 'react';
import './traitment.css';
import Administration from './administration';
import Procedure from './procedure';
import { FaEllipsisV } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";
import { FaBed } from "react-icons/fa6";
import Select from 'react-select';
import api from '../../service/caller';
import { format } from 'date-fns';

function PlanTraitement({ onNext, onBack, updatePatientDossier, patientId }) {
  const [treatments, setTreatments] = useState([]);
  const [medicationData, setMedicationData] = useState([]);
  const [procedureData, setProcedureData] = useState([]);
  const [newType, setNewType] = useState('');
  const [newMedicament, setNewMedicament] = useState('');
  const [status, setNewStatus] = useState('Ongoing');
  const [newRole, setNewRole] = useState('Docteurs');
  const [notes, setNewDetails] = useState('');
  const [followUpDate, setFollowUpDate] = useState();
  const [Userdata, setUserData] = useState();

  const handleMedicationChange = (medicationRows) => {
    setMedicationData(medicationRows);
  };
  const handleProcedureChange = (medicationRows) => {
    setProcedureData(medicationRows);
  };

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        // toast.error("Failed to fetch data");
      }
    };

    const fetchTraitment = async () => {
      try {
        const response = await api.get(`api/treatment-plans/get-plan/${patientId._id}`);
        if (response.data.data.length > 0) {
          console.log("pass")
          setFollowUpDate(format(new Date(response.data.data[0].followUpDate), "yyyy-MM-dd") || '')
          setNewDetails(response.data.data[0].notes || "")
          setNewStatus(response.data.data[0].status || "Ongoing")
        }
      } catch (error) {
        // toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
    fetchTraitment();
  }, [patientId]);

  const addTreatment = () => {
    const newTreatment = {
      id: Date.now(),
      type: newType,
      medicament: newMedicament,
      status: status,
      role: newRole,
      details: notes,
      observation: '' // initialisation vide pour l'ajout ultérieur d'une notes
    };
    const updatedTreatments = [...treatments, newTreatment];
    setTreatments(updatedTreatments);

    // Update patient dossier with both treatments and medication data
    updatePatientDossier({
      planTraitement: updatedTreatments,
      medications: medicationData
    });

    // Réinitialiser les champs
    setNewType('');
    setNewMedicament('');
    setNewStatus('Ongoing');
    setNewRole('Docteurs');
    setNewDetails('');
  };

  const saveMedications = async () => {
    try {
      console.log("poiyu", medicationData)
      // Save medication data to the backend
      await api.post(`api/treatment-plans/create-or-update`, {
        medications: medicationData,
        procedures: procedureData,
        followUpDate,
        notes,
        status,
        patientId: patientId.patientId._id,
        doctorId: Userdata._id,
        hospitalId: patientId.hospitalId._id,
        admissionId: patientId._id
      });
      console.log("Medications saved successfully:", { medications: medicationData, followUpDate, notes, status, patientId: patientId.patientId._id, doctorId: Userdata._id, hospitalId: patientId.hospitalId._id });
    } catch (error) {
      console.error("Failed to save medications:", error);
      // Consider adding a toast or alert here
    }
  };

  const handleSaveAndContinue = () => {
    // Save medications first
    saveMedications();
    // Then add treatment and navigate to next step
    //   addTreatment();
    onNext(4);
  };

  return (
    <div className="treatment-plan-container">
      <h1 className="treatment-plan-header">Plan de traitement</h1>

      <form className="treatment-plan-form">
        <section className="treatment-plan-section">
          <h3 className="treatment-plan-section-title">Medications</h3>
          {/* Composant Administration placé ici */}
          <div className="treatment-plan-placeholder">

            <Administration
              patientId={patientId}
              onMedicationChange={handleMedicationChange}
            />
          </div>
        </section>

        <section className="treatment-plan-section">
          <h3 className="treatment-plan-section-title">Procedure</h3>
          {/* Composant Procedure placé ici */}
          <div className="treatment-plan-placeholder">

            <Procedure
              patientId={patientId}
              onMedicationChange={handleProcedureChange}
            />
          </div>
        </section>

        <div className="treatment-plan-row">
          <div className="treatment-plan-group">
            <label className="treatment-plan-label">Follow up date</label>
            <input
              type="date"
              value={followUpDate}
              onChange={(e) => setFollowUpDate(e.target.value)}
              className="treatment-plan-input"
            />
          </div>

          <div className="treatment-plan-group">
            <label className="treatment-plan-label">Statut</label>
            <select
              value={status}
              onChange={(e) => setNewStatus(e.target.value)}
              className="treatment-plan-select"
            >
              <option value="Cancelled">Cancelled</option>
              <option value="Ongoing">Ongoing</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
        </div>

        <div className="treatment-plan-row">
          <div className="treatment-plan-group treatment-plan-full-width">
            <label className="treatment-plan-label">Détails</label>
            <input
              type="text"
              value={notes}
              onChange={(e) => setNewDetails(e.target.value)}
              placeholder="Ajouter des détails..."
              className="treatment-plan-input"
            />
          </div>
        </div>
      </form>

      <div className="treatment-plan-actions">
        <button
          className="treatment-plan-submit-btn"
          disabled={patientId.status !== "Active"}
          onClick={handleSaveAndContinue}
        >
          Commencer la surveillance quotidienne
        </button>

        {onBack &&
          <button
            className="treatment-plan-back-btn"
            onClick={() => onNext(1)}
          >
            Retour
          </button>
        }
      </div>
    </div>
  );
}

export default PlanTraitement;